import { OptionalProductDataFilter } from '@/store/Planogram/findAll';

export const OPTIONAL_PRODUCT_DATA_OPTIONS = [
    { label: 'Exibir todos os produtos', value: OptionalProductDataFilter.ALL },
    {
        label: 'Ocultar produtos com dados opcionais zerados',
        value: OptionalProductDataFilter.HIDE_EMPTY,
    },
    {
        label: 'Exibir somente produtos com dados opcionais zerados',
        value: OptionalProductDataFilter.ONLY_EMPTY,
    },
];

export const PLANOGRAM_MONITORED_FIELDS = [
    'store',
    'product',
    'barcode',
    'category',
    'optional_product_data',
];
